const MaritalStatuses = Object.freeze({
  SINGLE: 1,
  MARRIED: 2,
});

export default MaritalStatuses;
